// services/offlineDeliveryService.js

const OFFLINE_DELIVERIES_KEY = "offline_delivery_proofs";

class OfflineDeliveryService {
    // Save delivery proof to localStorage
    saveOfflineDelivery(deliveryData) {
        try {
            const offlineDeliveries = this.getOfflineDeliveries();

            // Add unique ID and timestamp
            const offlineDelivery = {
                id: `offline_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                ...deliveryData,
                savedAt: new Date().toISOString(),
                status: "pending",
            };

            offlineDeliveries.push(offlineDelivery);
            localStorage.setItem(OFFLINE_DELIVERIES_KEY, JSON.stringify(offlineDeliveries));

            console.log("✅ Delivery proof saved offline:", offlineDelivery.id);
            return offlineDelivery;
        } catch (error) {
            console.error("❌ Error saving offline delivery:", error);
            throw error;
        }
    }

    // Get all offline deliveries
    getOfflineDeliveries() {
        try {
            const data = localStorage.getItem(OFFLINE_DELIVERIES_KEY);
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("❌ Error getting offline deliveries:", error);
            return [];
        }
    }

    // Get count of pending offline deliveries
    getOfflineCount() {
        const deliveries = this.getOfflineDeliveries();
        return deliveries.filter((d) => d.status === "pending").length;
    }

    // Remove specific offline delivery
    removeOfflineDelivery(id) {
        try {
            const offlineDeliveries = this.getOfflineDeliveries();
            const filtered = offlineDeliveries.filter((d) => d.id !== id);
            localStorage.setItem(OFFLINE_DELIVERIES_KEY, JSON.stringify(filtered));
            console.log("✅ Removed offline delivery:", id);
        } catch (error) {
            console.error("❌ Error removing offline delivery:", error);
        }
    }

    // Update delivery status
    updateDeliveryStatus(id, status, error = null) {
        try {
            const offlineDeliveries = this.getOfflineDeliveries();
            const updated = offlineDeliveries.map((d) => (d.id === id ? { ...d, status, error, lastAttempt: new Date().toISOString() } : d));
            localStorage.setItem(OFFLINE_DELIVERIES_KEY, JSON.stringify(updated));
        } catch (error) {
            console.error("❌ Error updating delivery status:", error);
        }
    }

    // Clear all offline deliveries
    clearAll() {
        localStorage.removeItem(OFFLINE_DELIVERIES_KEY);
        console.log("✅ Cleared all offline deliveries");
    }

    // Convert blob URL to base64
    async blobUrlToBase64(blobUrl) {
        try {
            const response = await fetch(blobUrl);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("❌ Error converting blob to base64:", error);
            throw error;
        }
    }

    // Convert base64 to blob
    base64ToBlob(base64) {
        try {
            const arr = base64.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        } catch (error) {
            console.error("❌ Error converting base64 to blob:", error);
            throw error;
        }
    }
}

export default new OfflineDeliveryService();
